import { match } from 'ts-pattern'

import { percentageFromDecimal } from '@sequencehq/utils'

import { LineItem } from 'Invoices/types'
import { FormState } from './state.atoms'

export const lineItemToFormState = (lineItem: LineItem): FormState => {
  return {
    title: lineItem.title,
    quantity: lineItem.quantity,
    rate: match(lineItem.rateDisplay)
      .with('ABSOLUTE', () => lineItem.rate)
      .with('PERCENTAGE', () => percentageFromDecimal(lineItem.rate))
      .exhaustive(),
    rateDisplay: lineItem.rateDisplay,
    descriptionEnabled: !!lineItem.description,
    description: lineItem.description ?? '',
    externalIds: lineItem.externalIds
  }
}
